import { faSliders } from "@fortawesome/pro-solid-svg-icons"
import { getStore } from "app/store/store"
import { ADMIN_UI_CONFIG_PATH, HOME_PATH } from "page/model"
import { IMenuItem } from "ui/model"
import { uiActionCreator } from "ui/store/actions"
import { getNonAdminMenus } from "ui/store/state"
import { IUserInfo } from "user/model"
import { isSystemAdmin } from "user/tools/permissions"

export const setMenuExpansion = (isOpened: boolean): void => {
  getStore().dispatch(uiActionCreator.setMenuSize(isOpened))
}

export const setMenusForUser = (userInfo: IUserInfo): void => {
  const menus: IMenuItem[] = isSystemAdmin(userInfo) ? getAdminMenus() : getNonAdminMenus(userInfo)
  getStore().dispatch(uiActionCreator.setMenus(menus))
}

const getAdminMenus = (): IMenuItem[] => [
  {
    titleKey: "admin.menu.title",
    pagePaths: [],
    items: [
      {
        titleKey: "admin.ui-configuration.menu.title",
        icon: faSliders,
        pagePaths: [ADMIN_UI_CONFIG_PATH, HOME_PATH]
      }
    ]
  }
]
